"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toastService = exports.EToastType = void 0;
exports.ToastContainer = ToastContainer;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var EToastType;
(function (EToastType) {
    EToastType["SUCCESS"] = "success";
    EToastType["ERROR"] = "error";
    EToastType["WARNING"] = "warning";
    EToastType["INFO"] = "info";
})(EToastType || (exports.EToastType = EToastType = {}));
// Global toast state
var toastState = [];
var listeners = [];
var notifyListeners = function () {
    listeners.forEach(function (listener) { return listener(); });
};
exports.toastService = {
    get toasts() {
        return toastState;
    },
    showToast: function (message, type, duration) {
        if (type === void 0) { type = EToastType.INFO; }
        if (duration === void 0) { duration = 5000; }
        var id = "toast-".concat(Date.now(), "-").concat(Math.random());
        toastState = __spreadArray(__spreadArray([], toastState, true), [{ id: id, message: message, type: type, duration: duration }], false);
        notifyListeners();
        // Auto-remove after duration
        if (duration > 0) {
            setTimeout(function () {
                exports.toastService.removeToast(id);
            }, duration);
        }
    },
    removeToast: function (id) {
        toastState = toastState.filter(function (toast) { return toast.id !== id; });
        notifyListeners();
    },
};
function ToastContainer() {
    var _a = (0, react_3.useState)(toastState), toasts = _a[0], setToasts = _a[1];
    (0, react_3.useEffect)(function () {
        var listener = function () {
            setToasts(__spreadArray([], toastState, true));
        };
        listeners.push(listener);
        return function () {
            listeners = listeners.filter(function (l) { return l !== listener; });
        };
    }, []);
    if (toasts.length === 0)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { className: "fixed bottom-4 right-4 z-50 flex flex-col gap-2", children: toasts.map(function (toast) { return ((0, jsx_runtime_1.jsx)(ToastItem, { toast: toast }, toast.id)); }) }));
}
function ToastItem(_a) {
    var toast = _a.toast;
    var _b = (0, react_3.useState)(true), isVisible = _b[0], setIsVisible = _b[1];
    var handleClose = function () {
        setIsVisible(false);
        setTimeout(function () {
            exports.toastService.removeToast(toast.id);
        }, 300);
    };
    var getToastStyles = function () {
        switch (toast.type) {
            case EToastType.SUCCESS:
                return "border-success bg-success/10 text-success";
            case EToastType.ERROR:
                return "border-danger bg-danger/10 text-danger";
            case EToastType.WARNING:
                return "border-warning bg-warning/10 text-warning";
            case EToastType.INFO:
                return "border-primary bg-primary/10 text-primary";
            default:
                return "border-default bg-default/10";
        }
    };
    var getIcon = function () {
        switch (toast.type) {
            case EToastType.SUCCESS:
                return "solar:check-circle-bold";
            case EToastType.ERROR:
                return "solar:close-circle-bold";
            case EToastType.WARNING:
                return "solar:danger-triangle-bold";
            case EToastType.INFO:
                return "solar:info-circle-bold";
            default:
                return "solar:info-circle-bold";
        }
    };
    if (!isVisible)
        return null;
    return ((0, jsx_runtime_1.jsx)(react_1.Card, { className: "min-w-[300px] max-w-md border ".concat(getToastStyles(), " transition-all duration-300 ").concat(isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-full"), children: (0, jsx_runtime_1.jsxs)(react_1.CardBody, { className: "flex flex-row items-center gap-3 p-4", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: getIcon(), className: "h-5 w-5 flex-shrink-0" }), (0, jsx_runtime_1.jsx)("p", { className: "flex-1 text-sm font-medium", children: toast.message }), (0, jsx_runtime_1.jsx)("button", { onClick: handleClose, className: "flex-shrink-0 text-default-400 hover:text-default-600", "aria-label": "Close", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:close-circle-bold", className: "h-4 w-4" }) })] }) }));
}
